import { useRecoilState, useResetRecoilState } from 'recoil';

import { history } from '../_helpers';
import { authAtom } from '../_state';

import { deleteCache } from '../../Portal/Cache/cache';

import { isAlertCollectionsOpenAtom, isAlertContractsOpenAtom, collectionsAtom, recentCollectionsAtom, justDownloadedCollectionsAtom, listCollectionsByAffaireAtom, isListCollectionsByAffaireLoadedAtom, areCollectionsLoadedAtom, documentMetaListAtom, uploadedDocumentsAtom, justSentDocsAtom, areUploadedDocumentsLoadedAtom, areUploadedDocumentsLoadingAtom, externalVerifDocumentsAtom, idCollectionsDownloadingAtom, idNavettesDownloadingAtom, areExternalVerifDocumentsLoadedAtom } from '../../Portal/LoadData/LoadData';
import { userAtom } from '../../Portal/RecoilApp';

export { useFetchWrapper };

function useFetchWrapper() {
    const [auth, setAuth] = useRecoilState(authAtom);
    const resetCollections = useResetRecoilState(collectionsAtom);
    const resetRecentCollections = useResetRecoilState(recentCollectionsAtom);
    const resetJustDownloadedCollections = useResetRecoilState(justDownloadedCollectionsAtom);
    const resetListCollectionsByAffaire = useResetRecoilState(listCollectionsByAffaireAtom);
    const resetIsListCollectionsByAffaireLoaded = useResetRecoilState(isListCollectionsByAffaireLoadedAtom);
    const resetAreCollectionsLoaded = useResetRecoilState(areCollectionsLoadedAtom);
    const resetStateAlertCollections = useResetRecoilState(isAlertCollectionsOpenAtom);
    const resetStateAlertContracts = useResetRecoilState(isAlertContractsOpenAtom);
    const resetDocumentMetaList = useResetRecoilState(documentMetaListAtom);
    const resetUploadedDocuments = useResetRecoilState(uploadedDocumentsAtom);
    const resetJustSentDocs = useResetRecoilState(justSentDocsAtom);
    const resetAreUploadedDocumentsLoaded = useResetRecoilState(areUploadedDocumentsLoadedAtom);
    const resetAreUploadedDocumentsLoading = useResetRecoilState(areUploadedDocumentsLoadingAtom);
    const resetExternalVerifDocuments = useResetRecoilState(externalVerifDocumentsAtom);
    const resetIdCollectionsDownloading = useResetRecoilState(idCollectionsDownloadingAtom);
    const resetIdNavettesDownloading = useResetRecoilState(idNavettesDownloadingAtom);
    const resetAreExternalDocsLoaded = useResetRecoilState(areExternalVerifDocumentsLoadedAtom);
    const resetUser = useResetRecoilState(userAtom);

    return {
        get: request('GET'),
        post: request('POST'),
        put: request('PUT'),
        delete: request('DELETE')
    };

    function request(method) {
        return (url, body) => {
            const requestOptions = {
                method,
                headers: authHeader(url)
            };
            if (body) {
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.body = JSON.stringify(body);
            }
            return fetch(url, requestOptions).then(handleResponse)
            .catch((error) => {
                if (error.message === "Failed to fetch") {
                    return Promise.reject("Serveur hors ligne");
                }
                return Promise.reject(error);
            })
        }
    }
    
    // helper functions
    
    function authHeader(url) {
        // return auth header with jwt if user is logged in and request is to the api url
        const token = auth?.jwtToken;
        const isLoggedIn = !!token;
        const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
        if (isLoggedIn && isApiUrl) {
            return { Authorization: `Bearer ${token}` };
        } else {
            return {};
        }
    }
    
    function handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            
            if (!response.ok) {
                if ([401, 403].includes(response.status) && auth?.jwtToken) {
                    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                    localStorage.removeItem('user');
                    ['collections', 'listeCollectionsParAffaire'].forEach(cacheName => deleteCache(cacheName));
                    resetAllAtoms();
                    setAuth(null);
                    history.push('/portail_V2/login');
                }
    
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            return data;
        });
    }

    function resetAllAtoms() {
        resetCollections();
        resetRecentCollections();
        resetJustDownloadedCollections();
        resetListCollectionsByAffaire();
        resetIsListCollectionsByAffaireLoaded();
        resetAreCollectionsLoaded();
        resetStateAlertCollections();
        resetStateAlertContracts();
        resetDocumentMetaList();
        resetUploadedDocuments();
        resetJustSentDocs();
        resetAreUploadedDocumentsLoaded();
        resetAreUploadedDocumentsLoading();
        resetExternalVerifDocuments();
        resetIdCollectionsDownloading();
        resetIdNavettesDownloading();
        resetAreExternalDocsLoaded();
        resetUser();
    }
}
